<template>
  <div>
    <draft-card
      v-if="['draft', 'in_review'].includes(product.status)"
      :product="product"
      :enable="enableApprovalRequest"
    >
    </draft-card>

    <div v-for="(scope, i) in scopes" :key="i">
      <div class="row">
        <div
          class="col-xl-3 col-lg-4"
          v-for="(option, i) in scope.options"
          :key="i"
        >
          <button @click="selectOption(option)">
            <feature-card
              :icon="option.icon"
              :color="scope.color"
              :title="option.title"
              :warning="option.warning"
              :subtitle="option.subtitle"
            />
          </button>
        </div>
      </div>
      <hr
        v-if="i + 1 !== scopes.length"
        class="mt-5 mx-3 mb-0 border-neutral-100"
      />
    </div>

    <responsive-modal v-model="modal.checkin">
      <event-checkin-modal
        @success="modal.checkin = false"
        @repeated-code="modal.checkin = false"
        @close="modal.checkin = false"
      />
    </responsive-modal>
  </div>
</template>

<script>
import EventCheckinModal from "@/components/events/EventCheckinModal.vue";
import DraftCard from "@/components/product/details/DraftCard.vue";
import { approvalMessageUrl } from "@/functions/product";
import ProductDetailsMixin from "@/mixins/productDetails";

export default {
  components: { DraftCard, EventCheckinModal },
  mixins: [ProductDetailsMixin],
  data() {
    return {
      modal: {
        checkin: false
      }
    };
  },
  methods: {
    approvalMessageUrl,
    selectOption(option) {
      if (option.route) {
        const params = { id: this.$route.params.id, ...option.params };
        this.$router.push({ name: option.route, params });
      } else if (option.modal) this.modal[option.modal] = true;
    }
  },
  computed: {
    enableApprovalRequest() {
      return true;
      return !!this.product.checkout_build;
    }
  }
};
</script>
